import type { FaireProductEntity } from "../../entity_types/product";

export const p_k3a3nd2u3s: FaireProductEntity = {
  token: "p_k3a3nd2u3s",
  type: "product",
  name: "Organic Calendula Salve | Gentle and Healing, All Purpose",
  brandToken: "b_vt9rkhen92",
  brandName: "Dandelion Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/e1ec69952ca6afbbcf273bc7faa8b93e99aa119eada7f6bf8cfcfd50a2312a1a.jpeg",
  galleryImageUrls: [],
  priceDollars: 6,
  description:
    "Our Calendula Salve is a soothing, multi-purpose balm made with organic calendula flowers, celebrated for their natural ability to calm, repair, and nourish the skin. Infused in organic olive oil and blended with local beeswax, this golden salve is perfect for dry, irritated, or sensitive skin.\n\n🌼 Calendula is known for its anti-inflammatory and skin-healing properties\n🌿 Gently supports the healing of minor cuts, scrapes, rashes, and chapped skin\n🌻 Made with organic olive oil and pure beeswax for a soft, breathable barrier\n\nSafe for all ages and gentle enough for everyday use—even on delicate skin. Keep it in your medicine cabinet, diaper bag, or skincare routine for a natural go-to you can trust.\n\nHow to use: Apply a small amount to clean skin as needed.\n\nOur salve is handcrafted in small batches with intentional, high-quality ingredients that nourish the skin. The herbs are infused in olive oil for a minimum of 6 weeks to ensure a high concentration of medicinal property.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:56.856Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
